import { Schema } from '~/pages/person/components/create-person-form.schema';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedPersonRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreatePersonMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Schema) => {
      return await SSF.api.peopleCreate({
        ...payload,
        club: payload.club[1],
      });
    },
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: keys.lists(),
      });
    },
  });
}

export function useUpdatePersonMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...payload }: { id: number } & PatchedPersonRequest) => {
      return await SSF.api.peoplePartialUpdate(id, payload);
    },
    onSuccess: ({ data }) => {
      client.invalidateQueries({
        queryKey: keys.lists(),
      });

      client.invalidateQueries({
        queryKey: keys.detail(data.id),
      });
    },
  });
}

export function useDeletePersonMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.peopleDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
